import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';

import DataSecurityPage from '@/pages/data-security/DataSecurityPage.vue';
import DataSecurityExportPage from '@/pages/data-security/DataSecurityExportPage.vue';
import DataSecurityRemovePage from '@/pages/data-security/DataSecurityRemovePage.vue';

export default createRoutes({
  path: 'data-security',
  beforeEnter: authGuard,
  meta: {
    displayNav: true,
  },
  children: [
    {
      path: '',
      name: RouteNames.DATA_SECURITY.INDEX,
      component: DataSecurityPage,
    },
    {
      path: 'remove',
      name: RouteNames.DATA_SECURITY.REMOVE,
      component: DataSecurityRemovePage,
    },
    {
      path: 'export',
      name: RouteNames.DATA_SECURITY.EXPORT,
      component: DataSecurityExportPage,
    },
  ],
});
